/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_SoldInputs */

const en_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const fr_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendu`)
};

const de_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

const ja_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済み`)
};

const zh_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售出`)
};

const ar_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباع`)
};

const id_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjual`)
};

const it_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venduto`)
};

const ru_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продано`)
};

const pt_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const ko_listing_status_sold = /** @type {(inputs: Listing_Status_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 완료`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Listing_Status_SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_sold = /** @type {((inputs?: Listing_Status_SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_sold(inputs)
	if (locale === "es") return es_listing_status_sold(inputs)
	if (locale === "fr") return fr_listing_status_sold(inputs)
	if (locale === "de") return de_listing_status_sold(inputs)
	if (locale === "ja") return ja_listing_status_sold(inputs)
	if (locale === "zh") return zh_listing_status_sold(inputs)
	if (locale === "ar") return ar_listing_status_sold(inputs)
	if (locale === "id") return id_listing_status_sold(inputs)
	if (locale === "it") return it_listing_status_sold(inputs)
	if (locale === "ru") return ru_listing_status_sold(inputs)
	if (locale === "pt") return pt_listing_status_sold(inputs)
	return ko_listing_status_sold(inputs)
});